var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterfaceIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3849 79.3332V72.6326C77.3963 72.5362 77.4231 72.4421 77.4646 72.3537C79.7865 66.6285 80.9847 60.5411 80.9988 54.3983V45.6521C81.0176 44.8411 80.7356 44.0501 80.2029 43.4198C79.6702 42.7896 78.9216 42.361 78.0901 42.2105C77.595 42.1365 77.089 42.1666 76.6071 42.2987C76.1253 42.4307 75.6791 42.6616 75.2996 42.9753C74.92 43.289 74.6161 43.678 74.4089 44.1155C74.2017 44.5529 74.0961 45.0283 74.0995 45.5087V47.7131L74.1567 43.5214C74.1715 42.6744 73.8591 41.8521 73.2798 41.2126C72.7004 40.573 71.895 40.1614 71.0182 40.0567C70.5553 40.002 70.0856 40.039 69.6382 40.1652C69.1908 40.2914 68.7751 40.5043 68.4169 40.7906C68.0587 41.0769 67.7655 41.4306 67.5555 41.8298C67.3454 42.229 67.223 42.6653 67.1958 43.1117C67.1953 43.2855 67.1955 47.7131 67.1955 47.7131V43.4167C67.2096 42.9681 67.1308 42.5212 66.9637 42.1019C66.7966 41.6826 66.5446 41.2991 66.2221 40.9737C65.8996 40.6483 65.5131 40.3874 65.0848 40.206C64.6566 40.0246 64.195 39.9263 63.727 39.9168C63.2589 39.9074 62.7934 39.9869 62.3576 40.1508C61.9217 40.3147 61.524 40.5598 61.1875 40.8719C60.851 41.184 60.5823 41.5569 60.3969 41.969C60.2115 42.3812 60.1131 42.8245 60.1075 43.2734V47.7132V34.5498C60.1219 33.791 59.8785 33.0483 59.414 32.4337C58.9495 31.8192 58.289 31.3661 57.5324 31.143C57.0125 30.9968 56.4643 30.9687 55.9312 31.0609C55.3981 31.1532 54.8946 31.3631 54.4608 31.6742C54.027 31.9853 53.6747 32.389 53.4319 32.8533C53.189 33.3176 53.0623 33.8297 53.0617 34.3491V52.5442V47.6532C53.0617 46.3266 52.512 45.0543 51.5336 44.1162C50.5551 43.1782 49.228 42.6512 47.8443 42.6512H46.0508V55.9057C46.0508 59.2044 47.1845 62.4113 49.2767 65.0301L53.9028 71.2332C54.4079 71.773 54.7055 72.462 54.7465 73.1861V79.3323",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1309 14.3389H65.3484",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3489 24.3428H27.0879",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3923 27.6772C20.3133 27.6772 21.8706 26.1842 21.8706 24.3425C21.8706 22.5008 20.3133 21.0078 18.3923 21.0078C16.4713 21.0078 14.9141 22.5008 14.9141 24.3425C14.9141 26.1842 16.4713 27.6772 18.3923 27.6772Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9575 36.0142H27.0879",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.001 47.6855H27.0879",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7393 64.3588H4.47828C3.55578 64.3588 2.67106 64.0075 2.01876 63.3821C1.36646 62.7567 1 61.9085 1 61.0241V4.33467C1 3.45026 1.36646 2.60207 2.01876 1.9767C2.67106 1.35133 3.55578 1 4.47828 1H74.0438C74.9663 1 75.851 1.35133 76.5033 1.9767C77.1556 2.60207 77.5221 3.45026 77.5221 4.33467V36.0141",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0006 57.6895H7.95703V7.66943H70.566V36.0142",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3923 39.3485C20.3133 39.3485 21.8706 37.8556 21.8706 36.0139C21.8706 34.1722 20.3133 32.6792 18.3923 32.6792C16.4713 32.6792 14.9141 34.1722 14.9141 36.0139C14.9141 37.8556 16.4713 39.3485 18.3923 39.3485Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3923 51.0199C20.3133 51.0199 21.8706 49.527 21.8706 47.6853C21.8706 45.8436 20.3133 44.3506 18.3923 44.3506C16.4713 44.3506 14.9141 45.8436 14.9141 47.6853C14.9141 49.527 16.4713 51.0199 18.3923 51.0199Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 14.3389H16.6521",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceIco);
export default __webpack_public_path__ + "static/media/interface-ico.347175438784a16999da6635784f1b90.svg";
export { ForwardRef as ReactComponent };